import React, { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfiguratorContext } from '../contexts/ConfiguratorContext';
import { DataContext } from '../contexts/DataContext';
import useIsMobile from '../hooks/useIsMobile';
import OptionList from './OptionList';

interface Props {

}

const LandscapePicker: FunctionComponent<Props> = (props: Props) => {
    const { t } = useTranslation('landscapes');
    const { data } = useContext(DataContext);
    const { currentConfiguration, changeLandscape, setSelectedCategory } = useContext(ConfiguratorContext);
    const isMobile = useIsMobile();

    if (currentConfiguration === undefined) {
        return null;
    }

    const options = data.landscapes.map(e => ({
        id: e.id,
        thumbnail: `/api/landscapes/${e.id}/thumbnail?houseid=${currentConfiguration.houseId}&cachekey=${data.cacheKey}`,
        label: t(e.translationKey),
        selected: currentConfiguration.landscapeId === e.id,
        disabled: false,
    })).sort((a, b) => a.id > b.id ? 1 : -1);

    const selectLandscape = (id:number) => {
        if(isMobile){
            setSelectedCategory('None');
        }
        changeLandscape(id)
    }

    return (
        <>
            <h2>{t('title')}</h2>

            <div className='productPicker'>
                <OptionList options={options} onOptionClicked={option => selectLandscape(option.id)} />
            </div>
        </>
    );
}

export default LandscapePicker;
